export default __webpack_public_path__ + "static/media/login-bg.10da5964.svg";